import { choicesFromEnum } from "../../@helpers/choices-from-enum";

export enum TopUpTypes {
  CRYPTO = 'CRYPTO',
  WIRE = 'WIRE',
  CARD = 'CARD',
}

export const TopUpTypeChoices = choicesFromEnum(TopUpTypes);